import RAPIER from "@dimforge/rapier3d-compat";

import { ElevatorConfig, PhysicsTable } from "../../../entities/physics_table.js";

export const ELEVATOR_CONFIG: ElevatorConfig = {
  riseHeight: 1.1,
  periodSec: 3.6,
};

export class TableElevator
{
  private time = 0;
  private height = 0;

  constructor(
    private readonly table: PhysicsTable,
    private readonly config: ElevatorConfig,
    private readonly get_bodies: () => Iterable<RAPIER.RigidBody>
  )
  {}

  public step( dt: number ): void
  {
    this.time += dt;

    const period = Math.max( this.config.periodSec, 0.1 );

    const next = this.config.riseHeight * 0.5
      * ( 1 - Math.cos( this.time * ( 2 * Math.PI / period ) ) );

    const delta = next - this.height;
    this.height = next;

    if ( delta !== 0 )
      this.carry( delta );

    this.table.setElevation( this.height );
  }

  private carry( delta: number ): void
  {
    for ( const body of this.get_bodies() )
    {
      if ( !body.isValid() )
        continue;

      const p = body.translation();
      
      if ( this.table.isOutside( p ) )
        continue;

      body.setTranslation( { x: p.x, y: p.y + delta, z: p.z }, false );
    }
  }
}
